import $  = require('jquery');
import Modul from '../../Modul';

declare var CKEDITOR: any;

export default class ModuleInlineEditor {
    /**
     * @var Modul module on which the Inline Editor is used
     */
    module: Modul;

    /**
     * @var CKEDITOR CK Editor instance
     */
    editor: any;

    /**
     * @var {HTMLElement} the element to be edited
     */
    private element: HTMLElement;

    /**
     * @var {string} the ID of the element to be edited
     */
    private elementId: string;

    /**
     * Constructor
     *
     * @param Modul
     */
    constructor(module: Modul, element: string | HTMLElement) {
        this.module = module;
        if (typeof element === 'string') {
            this.elementId = element;
        } else {
            this.element = element;
        }
    }

    /**
     * @return {JQuery} the element to be edited as a jQuery object
     */
    getElement(): JQuery {
        if (this.element) {
            return $(this.element);
        }
        return $('#' + this.elementId);
    }

    /**
     * @param {object} options
     */
    startEditing(options: any) {
        let editableContainer: JQuery;

        // remove module from dragables during editing //
        this.module.disableDragging();

        editableContainer = this.getElement();

        // replace internal links so that they can be edited //
        editableContainer.html(this.module.replaceInternalLinksForEditor(
            editableContainer.html()
        ));

        // start editing on the content area //
        editableContainer.attr('contenteditable', 'true');

        // disable custom object editing controls from the browser as they cause more harm than good //
        try {
            if (document.execCommand) {
                document.execCommand('enableObjectResizing', false, 'false');
                document.execCommand('enableInlineTableEditing', false, 'false');
            }
        } catch (err) {
            // we really don't care if this fails //
        }

        this.editor = CKEDITOR.inline(this.getElement()[0], options);

        //if not set explicitly to not focus on editor at start up
        // focus on editor
        if (options.startupFocus !== false) {
            this.editor.focus();
        }

        if (options.hideToolbar) {
            this.hideToolbar();
        }

        this.editor.on('focus', () => {
            this.editor.focusManager.lock();
        });

        document.getElementById('diy-module-action-bar')
            .addEventListener('mousedown', this.onActionBarMouseDown);

    }

    stopEditing() {
        let editableContainer: JQuery;

        editableContainer = this.getElement();

        // do some cleanup when closing the module //
        try {
            if (document.execCommand) {
                document.execCommand('enableObjectResizing', false, 'true');
                document.execCommand('enableInlineTableEditing', false, 'true');
            }
        } catch (err) {
            // we really don't care if this fails //
        }
        editableContainer.removeAttr('contenteditable');
        editableContainer.blur();
        if (this.editor) {
            try {
                this.showToolbar();
                this.editor.destroy();
            } catch (e) {
                this.hideToolbar();
                // XXX sometimes IE trows some weird errors
                // do nothing then
            }
        }

        document.getElementById('diy-module-action-bar')
            .removeEventListener('mousedown', this.onActionBarMouseDown);
    }

    hideToolbar() {
        $('head').append(`
            <style id="${this.editor.id}-hide">
                #${this.editor.id}_top {
                    display: none !important;
                }
                .${this.editor.id}.cke_chrome {
                    border: 0 !important;
                }
            </style>
        `);
    }

    showToolbar() {
        $(`#${this.editor.id}-hide`).remove();
    }

    getHtmlData() {
        return this.editor.getData();
    }

    isDirty() {
        if (!this.editor) {
            return false;
        }

        return this.editor.checkDirty();
    }

    getEditor() {
        return this.editor;
    }

    // Mouse down events on Action Bar mess up with CKEditor's
    // current selection. This is a fix for most of such cases.
    private onActionBarMouseDown = (event: MouseEvent) => {
        if (event.target instanceof HTMLElement) {
            if ((event.target as HTMLElement).tagName.toLowerCase() === 'input') {
                return;
            }
        }

        event.preventDefault();
    };

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/ModuleInlineEditor.ts
 **/